<template lang="html">
  <div
    class="buy-box-trust-strip flex flex-col gap-2 border border-default p-3 text-sm text-muted"
  >
    <div class="flex items-center gap-2">
      <UIcon name="i-lucide-truck" class="size-4 shrink-0" />
      <NuxtLink
        to="/faq"
        class="transition-colors hover:text-highlighted"
      >
        Условия доставки
      </NuxtLink>
    </div>

    <div class="flex items-center gap-2">
      <UIcon name="i-lucide-rotate-ccw" class="size-4 shrink-0" />
      <NuxtLink
        to="/faq"
        class="transition-colors hover:text-highlighted"
      >
        Возврат
      </NuxtLink>
    </div>

    <div class="flex items-center gap-2">
      <UIcon name="i-lucide-shield-check" class="size-4 shrink-0" />
      <NuxtLink
        to="/faq"
        class="transition-colors hover:text-highlighted"
      >
        Безопасная оплата
      </NuxtLink>
    </div>

    <div
      v-if="showPromo"
      class="flex items-center gap-2"
    >
      <UIcon name="i-lucide-badge-percent" class="size-4 shrink-0" />
      <button
        type="button"
        class="text-left transition-colors hover:text-highlighted"
        @click="emit('open-promo')"
      >
        Условия акции
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  showPromo?: boolean
}>()

const emit = defineEmits<{
  'open-promo': []
}>()
</script>
